import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../../components/shared/Loading";

const Screen = lazy(() => import("../../../views/answer/QuestionnaireAnswer"));

export const Route = createFileRoute("/(open)/answer/$surveyId")({
  component: RouteComponent,
  params: {
    parse: (params) => (params.surveyId ? params : false),
  },
  staticData: {
    routeKey: "questionnaireAnswer",
    access: "open",
    layout: "blank",
    container: "default",
  },
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <Screen />
    </Suspense>
  );
}
